import {
	SET_FORM_STATE,
	RESET_FIELDS,
	GET_TOPOLOGY_2G,
	GET_TOPOLOGY_3G,
	GET_TOPOLOGY_4G,
	GET_TOPOLOGY_LABELS_2G,
	GET_TOPOLOGY_LABELS_3G,
	GET_TOPOLOGY_LABELS_4G,
	GET_SITES_IDS,
	GET_SITE_ID_LOCATION,
	TOGGLE_FILTERS,
	CLEAR_FORM,
	TOGGLE_SUMMARY_DIALOG,
} from '../actions/MapDriveTestsActions';

const initialState = {
	failuresFilters: [],
	failuresVoice: [],
	failuresPacket: [],
	cities: [],
	drives: [],
	dates: [],
	selectedDates: [],
	driveTests4g: [],
	driveTest: [],
	driveTestCodes: [],
	driveTestScanner: [],
	topology2gData: [],
	topology3gData: [],
	topology4gData: [],
	topologyLabels2gData: [],
	topologyLabels3gData: [],
	topologyLabels4gData: [],
	techBandVoice: [],
	techBandPacket: [],
	drivetestSummaryDropdown: [],
	drivetestSummary: [],
	sitesIds: [],
	siteIdLocation: [],
	openFilters: false,
	summaryDialogVisibility: false,
	formState: {
		isValid: false,
		values: {
			mapAutoZoom: true,
			mapFilters: true,
			mapSize: 10,
			scenario: 'all'
		},
		touched: {},
		errors: {},
	},
};

const mapDriveTestsReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case RESET_FIELDS: {
						return {
							...state,
							drives: [],
							dates: [],
						};
					}
					case GET_TOPOLOGY_2G: {
						return {
							...state,
							topology2gData: action.topology2gData
						};
					}
					case GET_TOPOLOGY_3G: {
						return {
							...state,
							topology3gData: action.topology3gData
						};
					}
					case GET_TOPOLOGY_4G: {
						return {
							...state,
							topology4gData: action.topology4gData
						};
					}
					case GET_TOPOLOGY_LABELS_2G: {
						return {
							...state,
							topologyLabels2gData: action.topologyLabels2gData
						};
					}
					case GET_TOPOLOGY_LABELS_3G: {
						return {
							...state,
							topologyLabels3gData: action.topologyLabels3gData
						};
					}
					case GET_TOPOLOGY_LABELS_4G: {
						return {
							...state,
							topologyLabels4gData: action.topologyLabels4gData
						};
					}
					case GET_SITES_IDS: {
						return {
							...state,
							sitesIds: action.sitesIds
						};
					}
					case GET_SITE_ID_LOCATION: {
						return {
							...state,
							siteIdLocation: action.siteIdLocation
						};
					}
					case TOGGLE_FILTERS: {
						return {
							...state,
							openFilters: action.openFilters
						};
					}
					case CLEAR_FORM: {
						return {
							...state,
							formState: initialState.formState
						};
					}
					case TOGGLE_SUMMARY_DIALOG: {
						return {
							...state,
							summaryDialogVisibility: action.visible
						};
					}
					default: {
						return state;
					}
	}
};

export default mapDriveTestsReducer;
